export default "__VITE_ASSET__cQw6KEoX__"